import { apiRequest } from './client';
import { NearbyShop, Shop } from '../types';

export interface CreateShopInput {
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  description?: string;
  googleMapsUrl?: string;
  googleReviewLink?: string;
}

export function createShop(token: string, input: CreateShopInput) {
  return apiRequest<Shop>('/shops', { method: 'POST', token, body: input });
}

export type UpdateShopInput = Partial<CreateShopInput>;

export function updateShop(token: string, id: string, input: UpdateShopInput) {
  return apiRequest<Shop>(`/shops/${id}`, { method: 'PATCH', token, body: input });
}

export interface ResolvedMapsLink {
  name?: string;
  address?: string;
  /** Absent when the link only carried a name+address text (no coordinates
   * embedded) — the caller must still get coordinates via GPS or manual entry. */
  latitude?: number;
  longitude?: number;
  resolvedUrl: string;
}

export function resolveMapsLink(token: string, url: string) {
  return apiRequest<ResolvedMapsLink>('/shops/resolve-maps-link', {
    method: 'POST',
    token,
    body: { url },
  });
}

export function myShops(token: string) {
  return apiRequest<Shop[]>('/shops/mine', { token });
}

export function nearbyShops(token: string, lat: number, lng: number, radiusKm = 20) {
  return apiRequest<NearbyShop[]>(
    `/shops/nearby?lat=${lat}&lng=${lng}&radiusKm=${radiusKm}`,
    { token },
  );
}

export function getShop(token: string, id: string) {
  return apiRequest<Shop>(`/shops/${id}`, { token });
}

export function rateShop(
  token: string,
  shopId: string,
  submissionId: string,
  stars: number,
  comment?: string,
) {
  return apiRequest<{ id: string; stars: number }>(`/shops/${shopId}/rate`, {
    method: 'POST',
    token,
    body: { submissionId, stars, comment: comment || undefined },
  });
}
